import React, {useCallback, useEffect, useRef, useState} from "react";
import {
    IonBackdrop,
    IonButton,
    IonCol,
    IonContent, IonGrid,
    IonHeader,
    IonItem,
    IonLabel, IonLoading, IonModal, IonPage,
    IonRow,
    IonTabButton, IonToast,
    IonToolbar,
    IonButtons, IonTitle, useIonModal, IonFooter, IonIcon, IonThumbnail, IonCardSubtitle
} from "@ionic/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Text from "../CommonStyles/Text";
import "./iframe.css"
import axios from "axios";
import styled from "@emotion/styled";
import './index.css';
import {Link, useNavigate} from "react-router-dom";
import CheckBox from "../../components/CheckBox/Index"
import {OverlayEventDetail} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import {formatMoney} from "../../util/formatHelpers";
import {usStates} from "../../constants";
import {
    add,
    arrowBack,
    chevronDownOutline,
    chevronUpOutline,
    closeOutline
} from "ionicons/icons";
import CurrencyInput from "react-currency-input-field";
import RegistrationPage from "./RegistrationPage";
import {getConfig} from "../../AppConfig";
import jwt_decode from "jwt-decode";
import moment from "moment";
import dayjs, {Dayjs} from "dayjs";
import {loadStripe} from '@stripe/stripe-js';
import { useDebouncedCallback } from 'use-debounce';

const Span = styled.span`
  padding-left: 0.5em;
`

const SpanImage = styled.span`
  margin-top: 5px;
`

const Image = styled.img`
  height: 30px;
`

export const Input = styled("input")`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 60px;
  width: 100%;
  border-radius: 10px;
  background-color: #e0ebf180;
  outline: none;
  border: 1px solid #66666660;
  padding-left: 15px;
  ::placeholder {
    font-size: 14px;
    padding-left: 0px;
  }
`;

const Select = styled("select")`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 60px;
  border-radius: 10px;
  background-color: #e0ebf180;
  outline: none;
  border: 1px solid #66666660;
  padding-left: 15px;
  ::placeholder {
    font-size: 14px;
    padding-left: 0px;
  }
`

const Option = styled("option")`
  box-sizing: border-box;
  background-color: #0000000d;
  outline: none;
  border: none;
  ::placeholder {
    font-size: 14px;
    padding-left: 4px;
  }
`

const ModalContent = styled.div`
      margin-top: 32px;
      margin-left: 32px;
      margin-right: 32px;
      height: 32em;
      text-align: left;
  
      h1 {
        font-family: var(--ion-font-family);
        font-size: 33px;
        font-weight: bold;
        text-align: center;
      }
      h2 {
        font-family: var(--ion-font-family);
        font-size: 26px;
        //font-weight: bold;
        text-align: center;
      }
      p {
        font-family: var(--ion-font-family);
      }
      letter-spacing: 0px;
      color: #333333;
    `


const LogoModalContent = styled.div`
      //margin-top: 32px;
      //margin-left: 32px;
      //margin-right: 32px;
      height: 32em;
      text-align: center;
  
      h1 {
        font-family: var(--ion-font-family);
        font-size: 23px;
        font-weight: bold;
        text-align: center;
      }
      h2 {
        font-family: var(--ion-font-family);
        font-size: 16px;
        //font-weight: bold;
        text-align: center;
      }
      p {
        font-family: var(--ion-font-family);
      }
      letter-spacing: 0px;
      color: #333333;
    `


const MessageModal = ({
                          onDismiss,
                          message,
                      }: {
    onDismiss: (data?: string | null | undefined | number, role?: string) => void;
    message: string;
}) => {
    const inputRef = useRef<HTMLIonInputElement>(null);
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Complete Registration</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonItem>
                    <IonLabel class={'ion-text-wrap'} style={{ fontSize: '18px'}}>{message}</IonLabel>
                </IonItem>
            </IonContent>
            <IonFooter>
                <IonRow style={{marginBottom: '20px'}}>
                    <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                        <IonButton onClick={() => onDismiss(inputRef.current?.value, 'cancel')} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                            Cancel
                        </IonButton>
                    </IonCol>
                    <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                        <IonButton onClick={() => onDismiss(inputRef.current?.value, 'ok')} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                            Ok
                        </IonButton>
                    </IonCol>
                </IonRow>
            </IonFooter>
        </IonPage>
    );
};

const RegisterPage = ({showCart, storeData, setStoreData, eventcode, auctioncode, reloadData, setReloadData, internalReload, setInternalReload}) => {
    const domainName =  window.location.hostname
    const domainNames = domainName.split('.')
    const [selectedTab, setSelectedTab] = React.useState('')
    const [hasNonFreeTypeItems, setHasNonFreeTypeItems] = React.useState(false)

    let interval;
    const [message, setMessage] = useState('Click OK to submit your guest registration information. If you have any changes to make later, use the “Update Registration” link found in your purchase receipt email or contact the event organizer.');
    const [present, dismiss] = useIonModal(MessageModal, {
        onDismiss: (data: string, role: string) => dismiss(data, role),
        message: message,
    });

    useEffect(()=> {
        // const handleStorageChange = (event) => {
        //     console.log('STORAGE!!')
        //     console.log(event)
        // }
        //
        // window.addEventListener('storage', handleStorageChange)
        // setReloadData(reloadData+1)
        // setInternalReload(internalReload+1)

        return () => {
            // window.removeEventListener('storage', handleStorageChange);
            // setTimerReload(timerReload+1)
            setReloadData(reloadData+1)
        }
    }, [])

    const debouncedClick = useDebouncedCallback(
        (value, item) => {
            quantityBlur(value, item);
        },
        // delay in ms
        100
    );

    const getStoreSetupData = async () => {
        const body = {auctioncode: auctioncode, eventcode: eventcode}
        const token = localStorage.getItem('tokenstore')

        const headers = token  ? {'Authorization': `Bearer ${token}`} : {}
        let url = `${apiUrl}/storesetup2`
        const {data} = await axios.post(url, body, {headers: headers})
        var parsedJson = JSON.parse(data?.jsonInfo)
        console.log(parsedJson)
        parsedJson.hasMerch = false
        parsedJson.hastickets = false
        parsedJson?.tabs?.map(tab => {
            if (tab.tabname == 'Merchandise') {
                if (tab?.sections?.length > 0) {
                    tab.sections.map(section => {
                        if (section?.data?.length > 0) {
                            const oneitme = section.data.find(item => item?.id > 0)
                            if (oneitme?.id > 0) {
                                parsedJson.hasMerch = true
                                tab.enabled = true
                            }
                            else {
                                tab.enabled = false
                            }
                        }
                    })
                }
            }
            if (tab.tabname == 'Tickets') {
                if (tab?.sections?.length > 0) {
                    let newSections = []
                    let sectionObj = []
                    tab.sections.map(section => {
                        if (section?.data?.length > 0) {
                            const oneitme = section.data.find(item => item?.id > 0)
                            newSections = [...newSections, ...section?.data]
                            if (oneitme?.id > 0) {
                                parsedJson.hastickets = true
                                tab.enabled = true
                            }
                            else {
                                tab.enabled = false
                            }
                        }
                    })
                    if (newSections && newSections?.length > 0) {
                        sectionObj = [{...tab.sections[0], data: newSections.sort((a, b) => a.itemorder - b.itemorder)}]
                    }
                    tab.sections = sectionObj
                }
            }
        })
        if (parsedJson.status === 'expired') {
            localStorage.removeItem("tokenstore")
            // history.push(`/${eventcode}/event`);
        }
        else if (parsedJson?.token?.length > 0) {
            console.log('setting token')
            localStorage.setItem('tokenstore', parsedJson.token)
        }
        if (parsedJson && parsedJson.tabs) {
            if (parsedJson.hascheckedout) {
                parsedJson.tabs.forEach(tab => {
                    if (tab.tabname === 'Tickets' || tab.tabname === 'Merchandise') {
                        tab.enabled = false
                    }
                })
                setSelectedTab('Cart')
            }
            else {
                if (parsedJson.hastickets) {
                    setSelectedTab(parsedJson.tabs[0].tabname)
                }
                else if (parsedJson.hasMerch) {
                    setSelectedTab(parsedJson.tabs[1].tabname)
                }
                else {
                    setSelectedTab('Cart')
                }
            }
        }
        if (showCart === 'cart') {
            setSelectedTab('Cart')
        }
        else if (showCart == 'merchandise') {
            setSelectedTab('Merchandise')
        }

        setStoreData({...storeData, ...parsedJson})
    }

    useEffect(() => {
        // setStoreData(setup1data)
        if (internalReload > 1) {
            getStoreSetupData()
        }
    }, [internalReload])

    // useEffect(()=> {
    //     // setTimerReload(timerReload+1)
    //     setInternalReload(internalReload+1)
    // }, [])

    function openRegistrationModal() {
        present({
            onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
                if (ev.detail.role === 'ok') {
                    localStorage.removeItem("tokenstore")
                    setReloadData(reloadData+1)
                    // setInternalReload(internalReload+1)
                    navigate(`/${eventcode}/event/`);
                }
            },
        });
    }

    function onWillDismiss(ev: CustomEvent<OverlayEventDetail>) {
        if (ev.detail.role === 'confirm') {
            console.log('confirm')
        }
        setQuantityModal({active: false, quantity: 0, item:''})
        if (summaryModal.active) {
            setSummaryModal({active: false})
            goFinish()
        }
    }

    const emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/


    const [itemQuantity, setItemQuantity] = React.useState({})
    const [itemPrice, setItemPrice] = React.useState({})
    const [cartExpired, setCartExpired] = React.useState(false)
    const [timerReload, setTimerReload] = React.useState<number>(null)
    const [paymentProcessFeesCheckbox, setPaymentProcessFeesCheckbox] = useState(false)
    const [toastState, setToastState] = useState({display: false, goback: false, message: ''})
    const [isLoading, setIsLoading] = useState(false)
    const [additionalDonation, setAdditionalDonation] = useState<number>(0)
    const [additionalDonationFinal, setAdditionalDonationFinal] = useState<number>(0)
    const [promoCodeAmount, setPromoCodeAmount] = useState<number>(0)
    const [promoCodeMessage, setPromoCodeMessage] = useState<string>('')
    const [promoCode, setPromoCode] = useState<string>("")
    const [showPromoInput, setShowPromoInput] = useState<boolean>(false)

    useEffect(() => {
        if (promoCode?.length > 0 || promoCodeAmount > 0) {
            setShowPromoInput(true)
        }
    }, [promoCode, promoCodeAmount])
    const [orderTotal, setOrderTotal] = useState(0)
    const [subtotalTotal, setSubtotalTotal] = useState(0)
    const [ccTotal, setCCTotal] = useState(0)
    const [ccTotalFee, setCCTotalFee] = useState(0)
    const [finishCheckout, setFinishCheckout] = useState(false)
    const [lstMessage, setListMessage] = useState<string | undefined>(undefined)
    const [skipForNow, setSkipForNow] = useState(false)
    const [registrationStats, setRegistrationStats] = useState({total: 0, registered: 0, skipped: 0, loaded: false})
    const [showFieldErrors, setShowFieldErrors] = useState<boolean>(false)
    const [firstname, setFirstName] = useState<string>("")
    const [lastname, setLastName] = useState<string>("")
    const [company, setCompany] = useState<string>("")
    const [phone, setPhone] = useState<string>("")
    const [address1, setAddress1] = useState<string>("")
    const [city, setCity] = useState<string>("")
    const [state, setState] = useState<string>("AL")
    const [zip, setZip] = useState<string>("")
    const [email, setEmail] = useState<string>("")
    const [paymentmethod, setPaymentMethod] = useState<string>("CREDIT")
    const [processorToken, setProcessorToken] = useState('');
    const [stripeObj, setStripeObj] = useState(null)
    const [reloadStripeElement, setReloadStripeElement] = useState<number>(0)
    const [stripeElement, setStripeElement] = useState(null)
    const [stripeAPIKey, setStripeAPIKey] = useState('')
    const [stripeCurrency, setStripeCurrency] = useState('usd')
    const [stripeAccountId, setStripeAccountId] = useState('')
    const [stripePaymentElement, setStripePaymentElement] = useState(null)
    const [invalidateIframe, setInvalidateIframe] = React.useState(1)

    const [cartData, setCartData] = React.useState({
        cartitems: [],
        allowpaymentoffees: false,
        hascheckedout: false,
        requiredemail: false,
        requiredzip: false,
        billme: false,
        ccfee: 0,
        paymentprocessorcode: 0,
        paymentprocessorisvalid: true,
        defaultpaymentoffees: false,
        paymentprocessorinfo: {
            stripeaccountid: '',
            stripeapikey: '',
            stripecurrency: '',
            creditcardiframe: 'https://secure.1stpaygateway.net/secure/PaymentHostedForm/v3/CreditCard',
            javascriptfile: 'https://secure.1stpaygateway.net/secure/PaymentHostedForm/Scripts/firstpay/firstpay.cryptogram.js',
            processorid: "70802",
            transactiontype: "Sale",
            transcenterid: "92754",
        },
        discountamount: 0,
        discountcode: '',
        hasdiscount: true,
        message: '',
        company: "",
        phone: "",
        first: "",
        last: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        paymentmethod: "",
        optionaltotal: 0,
        subtotal: 0,
        totalamount: 0,
        additionaldonation: undefined,
        logourl: '',
        itemtypecode: '',
    })

    const getStoreSetup = async () => {
        setStoreData({
            storewelcomeeventname: '',
            storewelcomeheader: '',
            storewelcomeeventlogourl: '',
            storewelcomebuttonevent: '',
            storewelcomebuttonauction: '',
            storewelcomebuttoneventshow: true,
            storewelcomebuttonauctionshow: true,
            torewelcomefooter: '',
            storewelcomeauctionlink: '',
            tabs: [],
            token: '',
            hascheckedout: false,
            hasmerch: true,
            hastickets: true,
            logourl: '',
            itemtypecode: '',
        })

        const body = {auctioncode: auctioncode, eventcode: eventcode}
        const token = localStorage.getItem('tokenstore')

        const headers = token  ? {'Authorization': `Bearer ${token}`} : {}
        let url = `${apiUrl}/storesetup2`
        const {data} = await axios.post(url, body, {headers: headers})
        const parsedJson = JSON.parse(data?.jsonInfo)

        if (parsedJson.status === 'expired') {
            localStorage.removeItem("tokenstore")
            navigate(`/${eventcode}/event`);
        }
        else if (parsedJson.token) {
            localStorage.setItem('tokenstore', parsedJson.token)
            setStoreData(parsedJson)
            // setTimerReload(parsedJson.token)
            // setTokenInternal(parsedJson.token)
        }
        else {
            setStoreData(parsedJson)
        }
    }

    const options = {
        mode: 'payment',
        amount: Math.round(orderTotal * 100),
        paymentMethodCreation: 'manual',
        // currency: 'usd',
        //confirm = true,
        setupFutureUsage: 'off_session',
        paymentMethodOptions: {
            us_bank_account: {
                verification_method: 'instant',
            },
        },
    };

    const loadStripeAccount = async () => {
        const stripeTempObj = await loadStripe(stripeAPIKey, {
            stripeAccount: stripeAccountId,
        });
        setStripeObj(stripeTempObj);
    }

    useEffect(() => {
        if (stripeObj && !stripePaymentElement && orderTotal > 0 && paymentmethod === 'CREDIT') {
            const elements = stripeObj.elements({...options, currency: stripeCurrency});
            setStripeElement(elements)
            const paymentElementOptions = {
                layout: {
                    type: 'tabs',
                    defaultCollapsed: false,
                },
                terms: {
                    applePay: 'never',
                    auBecsDebit: 'never',
                    bancontact: 'never',
                    card: 'never',
                    cashapp: 'never',
                    googlePay: 'never',
                    ideal: 'never',
                    paypal: 'never',
                    sepaDebit: 'never',
                    sofort: 'never',
                    usBankAccount: 'never'
                },
                paymentMethodOptions: {
                    us_bank_account: {
                        verification_method: 'instant',
                    },
                },
            };

            const paymentElement = elements.create('payment', paymentElementOptions);
            paymentElement.mount('#payment-element');

            paymentElement.on('change', async function(event) {
                if (event.complete) {
                    console.log('Stripe Form - complete')

                    await elements.submit();
                    const {error, confirmationToken} = await stripeObj.createConfirmationToken({elements: elements})
                    if (confirmationToken) {
                        setProcessorToken(confirmationToken.id)
                    }
                }
            });
            setStripePaymentElement(paymentElement)
        }
    }, [stripeObj, reloadStripeElement, paymentmethod])

    useEffect(() => {
        if (cartData?.paymentprocessorcode === 2) {
            if (cartData?.paymentprocessorinfo?.stripecurrency?.length > 0) {
                setStripeCurrency(cartData?.paymentprocessorinfo?.stripecurrency)
            }
            if (cartData?.paymentprocessorinfo?.stripeapikey) {
                setStripeAPIKey(cartData?.paymentprocessorinfo?.stripeapikey)
            }
            if (cartData?.paymentprocessorinfo?.stripeaccountid) {
                setStripeAccountId(cartData?.paymentprocessorinfo?.stripeaccountid)
            }
        }
    }, [cartData?.paymentprocessorinfo?.stripeaccountid])

    useEffect(() => {
        if (stripeAPIKey && stripeAPIKey.length > 0) {
            loadStripeAccount()
        }
    }, [stripeAPIKey, stripeAccountId])

    useEffect(() => {
        let token = localStorage.getItem("tokenstore")
        var decoded: any = ''
        if (token) {
            decoded = jwt_decode(token)

            const tokenDate = dayjs.unix(decoded.exp)
            const nowDate: any = moment()
            if (tokenDate.isAfter(nowDate)) {
                interval = setInterval(() => {
                    function pad(n) {
                        return (n < 10 ? "0" + n.toString() : n);
                    }

                    if (storeData?.tabs.find(item => item.tabname === 'Registration').enabled) {
                        clearInterval(interval)
                        setListMessage('')
                    }
                    else {
                        const d = dayjs.unix(decoded.exp)
                        const then: any = moment()
                        const now: any = moment(d.toDate(), "YYYY-MM-DD hh:mm:ss")

                        const calcSeconds = now.diff(then, 'seconds')
                        const days = Math.floor(calcSeconds / 24 / 60 / 60);
                        const hoursLeft = Math.floor((calcSeconds) - (days * 86400));
                        const hours = Math.floor(hoursLeft / 3600);
                        const minutesLeft = Math.floor((hoursLeft) - (hours * 3600));
                        const minutes = Math.floor(minutesLeft / 60);
                        const remainingSeconds = calcSeconds % 60;

                        // console.log(days + ' : ' + hours + ' : ' + minutes + ' : ' + remainingSeconds)
                        const currentDate: any = moment()
                        // console.log(currentDate)
                        // console.log(tokenDate.isBefore(currentDate))
                        if (tokenDate.isBefore(currentDate)) {
                            setListMessage('Cart Expired. Please reload the page')
                            localStorage.removeItem("tokenstore")
                            // setReloadData(reloadData + 1)
                            clearInterval(interval)
                            interval = null;
                            setCartExpired(true)
                        }
                        else if (Number(days) > 0) {
                            setListMessage('Cart Expires in ' + pad(days) + "d " + pad(hours) + "h " + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
                            setCartExpired(false)
                        } else if (Number(hours) > 0) {
                            setListMessage('Cart Expires in ' + pad(hours) + "h " + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
                            setCartExpired(false)
                        } else if (Number(minutes) > 0) {
                            setListMessage('Cart Expires in ' + pad(minutes) + 'm ' + pad(remainingSeconds) + 's')
                            setCartExpired(false)
                        } else if (Number(remainingSeconds) > 0) {
                            setListMessage('Cart Expires in ' + pad(remainingSeconds) + 's')
                            setCartExpired(false)
                        } else {
                            setListMessage('Cart Expired. Please reload the page')
                            localStorage.removeItem("tokenstore")
                            // setReloadData(reloadData + 1)
                            clearInterval(interval)
                            interval = null;
                            setCartExpired(true)
                            // setInternalReload(internalReload+1)
                            // navigate(`/${eventcode}/event`);
                        }
                    }

                }, 1000)
            }
            else {
                setListMessage('Cart Expired. Please reload the page')
                localStorage.removeItem("tokenstore")
                clearInterval(interval)
                interval = null;
                setCartExpired(true)
            }
        }
        return () => {
            clearInterval(interval)
        }
    }, [timerReload])

    const [quantityModal, setQuantityModal] = React.useState({active: false, quantity: 0, item: ""})
    const [logoModal, setLogoModal] = React.useState({active: false, url: '', name: "", desc: ""})
    const [summaryModal, setSummaryModal] = React.useState({active: false})
    const [maxQuantityPerTransModel, setMaxQuantityPerTransModal] = React.useState({active: false, maxquantity: 0, name: ""})

    const { apiUrl } = getConfig()
    const navigate = useNavigate()
    const storeCartAddItemUrl = `${apiUrl}/storecartadditem`
    const cartItemUrl = `${apiUrl}/storecart`
    const storecartdiscount = `${apiUrl}/storecartdiscount`
    const checkoutUrl = `${apiUrl}/storecheckout`
    const storeguestUrl = `${apiUrl}/storeguest`
    const checkoutTab = 'Checkout'

    useEffect(() => {
        const quantity = {...itemQuantity}
        const prices = {...itemPrice}
        storeData?.tabs?.map((item, index) => {
            item.sections.map(section => {
                section.data.map(itemdata => {
                    if (itemdata && itemdata.id > 0) {
                        quantity[itemdata.id] = Number(itemdata.quantity)
                        prices[itemdata.id] =  '$' + itemdata.price * Number(itemdata.quantity)
                    }
                })
            })
        })
        setItemQuantity(quantity)
        setItemPrice(prices)
        setTimerReload(timerReload+2)
    }, [storeData])

    useEffect(() => {
        setOrderTotal(0)
        const donation = Number(additionalDonationFinal)
        const discount = Math.round(promoCodeAmount * 100) / 100
        const subtotal = Number(subtotalTotal)
        const ccfee = cartData.ccfee / 100
        const ccTotalFee = (ccfee * (subtotal + donation - discount))
        setCCTotal(ccfee)
        setCCTotalFee(ccTotalFee)
        if (paymentProcessFeesCheckbox && paymentmethod === 'CREDIT') {
            setOrderTotal(
                subtotal + donation + ccTotalFee - discount
            )
            setReloadStripeElement(reloadStripeElement+1)
        }
        else if (subtotal + donation - discount > 0) {
            setCCTotal(0)
            setOrderTotal(subtotal + donation - discount)
            setReloadStripeElement(reloadStripeElement+1)
        }
    }, [
        additionalDonationFinal,
        paymentProcessFeesCheckbox,
        subtotalTotal,
        promoCodeAmount,
        paymentmethod
    ])


    useEffect(() => {
        if (selectedTab === 'Cart') {
            getCartItems()
        }
    }, [selectedTab])

    useEffect(() => {
        const script = document.createElement("script")

        script.src = cartData?.paymentprocessorinfo?.javascriptfile
        script.id =  "firstpay-script-cryptogram"
        script.type = "text/javascript"

        script.setAttribute("data-transcenter", cartData?.paymentprocessorinfo?.transcenterid)
        script.setAttribute("data-processor", cartData?.paymentprocessorinfo?.processorid)

        document.body.appendChild(script)

        var subtotal = 0
        cartData?.cartitems?.map((item) => {
            subtotal += item.lineamount
        })
        setSubtotalTotal(subtotal)

        if (cartData) {
            setFirstName(cartData.first)
            setLastName(cartData.last)
            setAddress1(cartData.address)
            setCompany(cartData.company)
            setPhone(cartData.phone)
            setCity(cartData.city)
            setState(cartData.state)
            setZip(cartData.zip)
            setEmail(cartData.email)
            if (cartData && cartData?.paymentmethod && cartData?.paymentmethod !== "0") {
                console.log('setting up payment method - ' + cartData?.paymentmethod)
                setPaymentMethod(cartData.paymentmethod)
            }
            else {
                console.log('setting up payment method - CREDIT')
                setPaymentMethod('CREDIT')
            }

            setPaymentProcessFeesCheckbox(cartData.defaultpaymentoffees === true)
            setPromoCode(cartData.discountcode)
            setPromoCodeAmount(cartData.discountamount)
            setAdditionalDonationFinal(0)
            if (Number(cartData.additionaldonation) > 0) {
                setAdditionalDonation(cartData.additionaldonation)
                setAdditionalDonationFinal(cartData.additionaldonation)
            }
            else {
                setAdditionalDonation(0);
                setAdditionalDonationFinal(0);
            }
        }
    }, [cartData])

    useEffect(() => {
        setPaymentMethod('BILLME')

        window.addEventListener("message", processPayment, false)
        return () => {
            window.removeEventListener("message", processPayment)
        }
    }, [])

    const processPayment = (e: any) => {
        if (e.data.firstpay) {
            const ccData = e.data
            if (ccData.type === 'newCryptogram') {
                setProcessorToken(ccData.cryptogram)
            }
        }
    }

    const clickCheckout = async () => {
        clearInterval(interval)
        setShowFieldErrors(true)
        setIsLoading(true)

        if (orderTotal > 0 && paymentmethod === "CREDIT" && (!processorToken || processorToken.length <= 0)) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Please enter a valid credit card.`})
        }
        else if (!firstname) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `First name is required for checkout.`})
        }
        else if (!lastname) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Last name is required for checkout.`})
        }
        else if (!address1) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Address is required for checkout.`})
        }
        else if (!city) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `City is required for checkout.`})
        }
        else if (!state) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `State is required for checkout.`})
        }
        else if (!zip) {  //&& cartData?.requiredzip) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Zip is required for checkout.`})
        }
        else if (cartData?.requiredemail && !emailRegex.test(email)) {
            setIsLoading(false)
            return setToastState({ display: true, goback: false, message: `Please enter a valid email.`})
        }
        else {
            const body = {
                "first":firstname,
                "last":lastname,
                "company": company,
                "phone": phone,
                "address":address1,
                "city":city,
                "state":state,
                "zip":zip,
                "email":email,
                "subtotal": subtotalTotal,
                "discountamount": promoCodeAmount,
                "additionaldonation": additionalDonationFinal,
                "ccfeesamount": ccTotal,
                "totalamount": orderTotal,
                "paymentmethod": orderTotal > 0 ? paymentmethod : 'FREE',
                "processortoken": processorToken
            }
            const token = localStorage.getItem('tokenstore')

            try {
                const {data} = await axios.put(checkoutUrl, body, {headers: {
                        'Authorization': `Bearer ${token}`
                    }})
                const parsedData = JSON.parse(data.jsonString)
                if (parsedData.status === 'expired') {
                    localStorage.removeItem("tokenstore")
                    // setReloadData(reloadData+1)
                    // setInternalReload(internalReload+1)
                    navigate(`/${eventcode}/event`);
                }
                if (parsedData.status === 'success') {
                    if (parsedData && parsedData?.token) {
                        localStorage.setItem('tokenstore', parsedData.token)
                        await getStoreSetup()
                        storeData.tabs.map((tab, index) => {
                            if (tab.tabname === selectedTab) {
                                setSelectedTab(storeData.tabs[index + 1].tabname)
                            }
                        })
                    }
                    else {
                        // goFinish()
                        setSummaryModal({active: true})
                    }
                }
                else if (parsedData.status === 'failed') {
                    return setToastState({ display: true, goback: false, message: parsedData?.message})
                }
            } finally {
                setIsLoading(false)
            }
        }
    }

    const getCartItems = async () => {
        const body = {}
        const token = localStorage.getItem('tokenstore')

        const {data} = await axios.get(cartItemUrl, {headers: {
                'Authorization': `Bearer ${token}`
            }})
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData.status === 'expired') {
            localStorage.removeItem("tokenstore")
            navigate(`/${eventcode}/event`);
        }
        else if (parsedData.status === 'success') {
            setPaymentProcessFeesCheckbox(parsedData.defaultpaymentoffees)
            setCartData(parsedData)
            setInvalidateIframe(invalidateIframe+1)
            setStripePaymentElement(null)
            setReloadStripeElement(reloadStripeElement+1)
        }
    }

    const getDiscount = async (discountcode) => {
        const body = {"discountcode": discountcode}
        const token = localStorage.getItem('tokenstore')

        const {data} = await axios.post(storecartdiscount, body, {headers: {
                'Authorization': `Bearer ${token}`
            }})
        const parsedData = JSON.parse(data.jsonString)
        if (parsedData.status === 'expired') {
            localStorage.removeItem("tokenstore")
            // setReloadData(reloadData+1)
            // setInternalReload(internalReload+1)
            navigate(`/${eventcode}/event`);
        }
        else if (parsedData.status === 'success') {
            console.log(parsedData.discountamount)

            return {discountamount: parsedData.discountamount, message: parsedData.message}
        }
        else {
            return {discountamount: 0, message: parsedData.message}
        }
    }

    const validSectionData = (data) => {
        if (data && data?.length > 0) {
            return data.some(item => item && item?.id > 0)
        }
        return false
    }

    const quantityUpdate = async (value, item) => {
        // if (item.quantity >= 0) {
            if (item.maxquantitypertransaction >= Number(value) || item.maxquantitypertransaction == 0) {
                const quantity = {...itemQuantity}
                quantity[item.id] = Number(value)
                setItemQuantity(quantity)

                var prices = {...itemPrice}
                prices[item.id] =  '$' + item.price * value
                console.log(item.price * value)
                setItemPrice(prices)
            }
            else {
                setMaxQuantityPerTransModal({active: true, maxquantity: item.maxquantitypertransaction, name: item.name})
            }
        // }
    }

    const quantityBlur = async (value, item) => {
        console.log(item)
        const body = {quantity: Number(value), itemid: Number(item.id)}
        const token = localStorage.getItem('tokenstore')

        if (item?.maxquantitypertransaction < value) {
            const quantity = {...itemQuantity}
            quantity[item.id] = Number(item.maxquantitypertransaction)

            var prices = {...itemPrice}
            prices[item.id] =  '$' + item.price * quantity[item.id]
            setItemPrice(prices)
            setItemQuantity(quantity)
            setMaxQuantityPerTransModal({active: true, maxquantity: item.maxquantitypertransaction, name: item.name})
        }
        else {
            const {data} = await axios.post(storeCartAddItemUrl, body, {headers: {
                    'Authorization': `Bearer ${token}`
                }})
            const parsedData = JSON.parse(data.jsonString)
            if (parsedData.status === 'expired') {
                localStorage.removeItem("tokenstore")
                setReloadData(reloadData+1)
                // setInternalReload(internalReload+1)
                navigate(`/${eventcode}/event`);
            }
            else if (parsedData.status === 'failure') {
                const correctedQty = Number(parsedData.quantityremaining)
                const correctedLineAmount = item.price * correctedQty
                const quantity = {...itemQuantity}
                quantity[parsedData.itemid] = correctedQty
                setItemQuantity(quantity)
                const prices = {...itemPrice}
                prices[item.id] = '$' + correctedLineAmount
                setItemPrice(prices)
                const updatedCartItems = (cartData.cartitems ?? []).map((cartItem: any) =>
                    cartItem.id === parsedData.itemid
                        ? {...cartItem, quantity: correctedQty, lineamount: correctedLineAmount}
                        : cartItem
                )
                setCartData({...cartData, cartitems: updatedCartItems})
                setQuantityModal({active: true, quantity: parsedData.quantityremaining, item: parsedData.itemname})
            }
        }
    }

    const calcItemPrice = (item) => {
        // console.log('calcItemPrice')
        // console.log(item.price)
        var quantityValue = itemQuantity[item.id]
        if (item.maxquantitypertransaction > quantityValue) {
            quantityValue = item.maxquantitypertransaction
        }

        const priceUnformatted = Number(itemPrice[item.id]?.split("$").pop())
        const total = formatMoney(priceUnformatted)
        const price = formatMoney(item.price)

        var totalPrice = (item.id in itemPrice) ? `X ${price} = ${total}` : `X ${price} = $0`
        if (item.itemtypecode == 4) {
            totalPrice = "FREE"
        }

        return totalPrice
    }

    const goBack = () => {
        storeData.tabs.map((tab, index) => {
            if (tab.tabname === selectedTab) {
                if (tab.tabname == 'Cart') {
                    if (storeData.hasMerch) {
                        setSelectedTab(storeData.tabs[index - 1].tabname)
                    }
                    else {
                        setSelectedTab(storeData.tabs[index - 2].tabname)
                    }
                }
                else {
                    setSelectedTab(storeData.tabs[index - 1].tabname)
                }
            }
        })
        contentRef.current?.scrollToTop(0)
    }
    const goNext = () => {
        storeData.tabs.map((tab, index) => {
            if (tab.tabname === selectedTab) {
                if (tab.tabname == 'Tickets') {
                    if (storeData.hasMerch) {
                        setSelectedTab(storeData.tabs[index + 1].tabname)
                    }
                    else {
                        setSelectedTab(storeData.tabs[index + 2].tabname)
                    }
                }
                else {
                    setSelectedTab(storeData.tabs[index + 1].tabname)
                }
            }
        })
        contentRef.current?.scrollToTop(0)
    }

    const saveAndContinue = () => {
        navigate(`/${eventcode}/event/`);
    }

    const goFinish = () => {
        if (registrationStats.total > 0) {
            openRegistrationModal()
        } else {
            localStorage.removeItem("tokenstore")
            setReloadData(reloadData+1)
            navigate(`/${eventcode}/event/`);
        }
    }

    const hasNext = () => {
        var nextBool = false
        storeData?.tabs?.map((tab, index) => {
            if (tab.tabname === selectedTab) {
                if (storeData.tabs.length > (index + 1)) {
                    nextBool = true
                }
            }
        })
        return nextBool
    }

    const hasBack = () => {
        var nextBool = false
        storeData?.tabs?.map((tab, index) => {
            if (tab.tabname === selectedTab) {
                if (index > 0) {
                    nextBool = true
                }
            }
        })
        return nextBool
    }

    const disableCheckout = () => {
        if (isLoading) {
            return true
        }
        else if (cartExpired) {
            return true
        }
        else if (Number(additionalDonationFinal) > 0) {
            return false
        }
        else if (cartData?.cartitems?.length <= 0) {
            return true
        }
        else if (cartData?.cartitems?.length > 0) {
            return false
        }
        else if (Number(additionalDonationFinal) <= 0 || additionalDonationFinal == undefined) {
            return true
        }
        else {
            return false
        }
    }

    const getButtons = () => {
        const cartButton = (
                <IonCol style={{display: 'flex', paddingTop: '4px', paddingBottom: '4px'}} className="ion-justify-content-center ion-col-custom">
                    <IonButton disabled={disableCheckout()} onClick={() => {clickCheckout()}} size="large" style={{ width: '100%' }} expand="block" fill="solid" color={'primary'}>
                        Checkout
                    </IonButton>
                </IonCol>
        )

        const backButton = (
                <IonCol style={{display: 'flex', paddingTop: '4px', paddingBottom: '4px'}} className="ion-justify-content-center ion-col-custom">
                    <IonButton disabled={cartExpired} onClick={goBack} size="large" style={{ width: '100%' }} expand="block" fill="outline" color={'primary'}>
                        Back
                    </IonButton>
                </IonCol>
        )
        const nextButton = (
                <IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">
                    <IonButton disabled={cartExpired} onClick={goNext} size="large" style={{ maxWidth: '600px', width: '500px' }} expand="block" fill="solid" color={'primary'}>
                        Next
                    </IonButton>
                </IonCol>
        )


        if (finishCheckout || (cartData?.hascheckedout && !storeData?.tabs.find(item => item.tabname === 'Registration').enabled)) {
            return  (
                <IonRow>
                    <IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">
                        <IonButton onClick={goFinish} size="large" style={{ maxWidth: '600px', width: '500px' }} expand="block" fill="solid" color={'primary'}>
                            Finish
                        </IonButton>
                    </IonCol>
                </IonRow>
            )
        }
        else if (selectedTab === 'Cart') {
            if (storeData?.hascheckedout) {
                return (
                    <>
                        <IonRow>
                            {nextButton}
                        </IonRow>
                    </>
                )
            }
            else {
                return (
                    <>
                        <IonRow style={{ maxWidth: '800px', margin: '0 auto', width: '100%' }}>
                            {backButton}
                            {cartButton}
                        </IonRow>
                    </>
                )
            }
        }
        else if (hasBack() && hasNext()) {
            if (selectedTab === 'Tickets' || selectedTab === 'Merchandise') {
                return null
            }
            return (
                <>
                    <IonRow>
                        {nextButton}
                        {backButton}
                    </IonRow>
                </>
            )
        }
        else if (hasNext()) {
            if (selectedTab === 'Tickets' || selectedTab === 'Merchandise') {
                return null
            }
            return nextButton
        }
        else {
            const allTouched = registrationStats.total > 0 &&
                registrationStats.skipped >= registrationStats.total
            const finishEnabled = selectedTab !== 'Registration' ||
                (registrationStats.loaded && registrationStats.total === 0) ||
                allTouched
            return  (
                <IonRow>
                    {/*<IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">*/}
                    {/*    <IonButton onClick={saveAndContinue} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>*/}
                    {/*        Save and Continue Later*/}
                    {/*    </IonButton>*/}
                    {/*</IonCol>*/}
                    <IonCol style={{display: 'flex'}} className="ion-justify-content-center ion-col-custom">
                        <IonButton onClick={goFinish} disabled={!finishEnabled} size="large" style={{ maxWidth: '600px', width: '500px' }} expand="block" fill="solid" color={'primary'}>
                            Finish
                        </IonButton>
                    </IonCol>
                </IonRow>
            )
        }
    }

    const calcAmountWon = () => {
        return cartData.cartitems.reduce((acc: any, curr: any) => {
            return acc + curr.lineamount
        }, 0)
    }

    const addAdditionalDonation = (value) => {
        if (value.float > 100000) {
            setAdditionalDonation(100000)
            setAdditionalDonationFinal(100000)
            return
        }
        else {
            setAdditionalDonation(value.float)
            setAdditionalDonationFinal(value.float)
        }
    }

    const getDiscountAmount = async () => {
        const discountObj = await getDiscount(promoCode)
        
        setPromoCodeAmount(Math.round(discountObj.discountamount * 100) / 100)
        setPromoCodeMessage(discountObj.message)
    }

    const updatePromoCode =  (e: any) => {
        if(e.target.value < 0){
            return
        }
        setPromoCode(e.target.value)
    }

    const GoEmerchant = () => {
        return (
            <div >
                <SpanImage id="goe-logo">Payment securely processed by: <a href="https://goemerchant.com" target="_blank">
                    <Image alt="goEmerchant Payment Processing" src="https://donorsnap.com/graphics/entry/goe-logo.png"></Image>
                </a></SpanImage>
            </div>
        )
    }

    const displayLogoUrl = (item) => {
        if (item?.logourl && item?.logourl?.length > 0) {
            setLogoModal({active: true, url: item?.logourl, name: item?.name, desc: item?.description})
        }
    }

    const getDataItems = (items) => {
        const validItems = items?.filter(item => item && item?.name?.length > 0) ?? []

        const elems = validItems.map((item) => {
            const qty = itemQuantity[item.id] ?? 0
            const priceUnformatted = Number(itemPrice[item.id]?.split("$").pop()) || 0
            const subtotal = formatMoney(priceUnformatted)
            const price = formatMoney(item.price)
            const isSoldOut = !item?.isquantityunlimited && item?.quantityremaining <= 0
            const isFree = item.itemtypecode == 4
            const disabled = storeData?.hascheckedout || cartExpired

            return (
                <div key={item.id} style={{
                    width: '100%',
                    backgroundColor: '#fff',
                    border: '1px solid #e0e0e0',
                    borderRadius: '14px',
                    padding: '28px 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'stretch', gap: '12px' }}>
                        {/* Left: thumbnail + name + description + controls */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {/* Thumbnail + name + description */}
                            <div
                                style={{ display: 'flex', alignItems: 'center', gap: '10px', minHeight: '48px', cursor: item?.logourl ? 'pointer' : 'default' }}
                                onClick={() => displayLogoUrl(item)}
                            >
                                {item?.logourl && item?.logourl.length > 0 && (
                                    <IonThumbnail style={{ marginRight: '4px', flexShrink: 0, '--size': '64px', borderRadius: '8px', overflow: 'hidden' }}>
                                        <img alt="" src={item?.logourl} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </IonThumbnail>
                                )}
                                <div>
                                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#111', lineHeight: '1.3' }}>{item.name}</div>
                                    {item.description && item.description.length > 0 && (
                                        <div style={{ fontSize: '14px', color: '#999', lineHeight: '1.4', marginTop: '2px' }}>{item.description}</div>
                                    )}
                                </div>
                            </div>

                            {/* Quantity controls */}
                            {isSoldOut ? (
                                <div style={{ fontSize: '13px', color: '#666' }}>SOLD OUT</div>
                            ) : (
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignSelf: 'flex-start',
                                    alignItems: 'center',
                                    backgroundColor: '#f0f0f0',
                                    borderRadius: '10px',
                                    overflow: 'hidden',
                                    border: '1px solid #d0d0d0',
                                    opacity: disabled ? 0.5 : 1,
                                    pointerEvents: disabled ? 'none' : 'auto',
                                }}>
                                    <button
                                        onClick={() => { const n = qty > 0 ? qty - 1 : 0; quantityUpdate(n, item); debouncedClick(n, item) }}
                                        style={{ background: 'none', border: 'none', width: '38px', height: '36px', fontSize: '18px', color: '#555', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                                    >−</button>
                                    <div style={{ width: '1px', height: '20px', backgroundColor: '#d0d0d0', flexShrink: 0 }} />
                                    <input
                                        type="number"
                                        min="0"
                                        value={qty}
                                        onChange={(e) => { const n = Math.max(0, Number(e.target.value)); quantityUpdate(n, item); }}
                                        onFocus={(e) => e.target.select()}
                                        onBlur={(e) => { const n = Math.max(0, Number(e.target.value)); debouncedClick(n, item); }}
                                        style={{ width: '40px', alignSelf: 'stretch', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', fontWeight: '500', color: '#333', backgroundColor: '#fff', border: 'none', outline: 'none', textAlign: 'center', padding: 0, MozAppearance: 'textfield' } as React.CSSProperties}
                                    />
                                    <div style={{ width: '1px', height: '20px', backgroundColor: '#d0d0d0', flexShrink: 0 }} />
                                    <button
                                        onClick={() => { const n = qty + 1; quantityUpdate(n, item); debouncedClick(n, item) }}
                                        style={{ background: 'none', border: 'none', width: '38px', height: '36px', fontSize: '18px', color: '#555', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                                    >+</button>
                                </div>
                            )}
                        </div>

                        {/* Right: price top, subtotal bottom */}
                        <div style={{ flexShrink: 0, textAlign: 'right', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#111' }}>
                                {isFree ? 'FREE' : price}
                            </div>
                            <div>
                                <div style={{ fontSize: '11px', color: '#aaa' }}>Subtotal</div>
                                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#111' }}>{subtotal}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                padding: '12px 4px',
                maxWidth: '800px',
                margin: '0 auto',
            }}>
                {elems}
            </div>
        )
    }

    const getCart = () => {
        const idToTab: Record<number, string> = {}
        storeData?.tabs?.forEach((tab: any) => {
            tab?.sections?.forEach((section: any) => {
                section?.data?.forEach((storeItem: any) => {
                    if (storeItem?.id > 0) idToTab[storeItem.id] = tab.tabname
                })
            })
        })

        const groups: { tabname: string; items: any[] }[] = []
        cartData?.cartitems?.forEach((item: any) => {
            const tabname = idToTab[item.id] ?? 'Items'
            const existing = groups.find(g => g.tabname === tabname)
            if (existing) existing.items.push(item)
            else groups.push({ tabname, items: [item] })
        })

        var subtotal = 0
        const detailRows = groups.map((group, gi) => {
            return (
                <div key={group.tabname}>
                    {groups.length > 1 && (
                        <div style={{ fontSize: '11px', fontWeight: '700', color: '#aaa', letterSpacing: '0.06em', textTransform: 'uppercase', padding: '10px 0 4px', marginTop: gi > 0 ? '4px' : 0, borderTop: gi > 0 ? '1px solid #f0f0f0' : 'none' }}>
                            {group.tabname}
                        </div>
                    )}
                    {group.items.map((item: any) => {
                        subtotal += item.lineamount
                        return (
                            <div key={item.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 0', borderBottom: '1px solid #f5f5f5' }}>
                                <div style={{ fontSize: '16px', color: '#333' }}>{item.name}</div>
                                <div style={{ fontSize: '16px', color: '#666', textAlign: 'right', flexShrink: 0, marginLeft: '12px' }}>
                                    {item.itemtypecode == 4
                                        ? `${item.quantity} FREE`
                                        : `${item.quantity} × $${item.price} = $${item.lineamount}`
                                    }
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        })

        return (
            <div style={{ maxWidth: '800px', margin: '0 auto', padding: '12px 16px 100px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '16px' }}>
                    {cartData?.cartitems?.length > 0 && <div style={{ flex: 1, backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '12px', padding: '16px 20px' }}>
                        <div style={{ fontSize: '11px', fontWeight: '700', color: '#999', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '12px' }}>Order Summary</div>
                        {detailRows}
                        {cartData?.cartitems && (
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #f0f0f0' }}>
                                <div style={{ fontSize: '14px', fontWeight: '700' }}>Subtotal</div>
                                <div style={{ fontSize: '14px', fontWeight: '700' }}>{formatMoney(subtotal)}</div>
                            </div>
                        )}
                    </div>}

                    <div style={{ backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '12px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
                        {cartData?.paymentprocessorisvalid && (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
                                <div style={{ fontSize: '13px', color: '#555' }}>Additional donation</div>
                                <CurrencyInput
                                    intlConfig={{ locale: 'en-US', currency: 'USD' }}
                                    name="additionalDonation"
                                    style={{ width: '110px', height: '36px', borderRadius: '8px', border: '1px solid #d0d0d0', textAlign: 'right', paddingRight: '10px', paddingLeft: '8px', backgroundColor: '#fafafa', outline: 'none', fontSize: '14px', boxSizing: 'border-box', flexShrink: 0 }}
                                    placeholder="$0"
                                    decimalsLimit={0}
                                    disabled={cartData?.hascheckedout}
                                    onValueChange={(value, name, values) => addAdditionalDonation(values)}
                                />
                            </div>
                        )}

                        {cartData?.cartitems && cartData?.paymentprocessorisvalid && (
                            <div>
                                {!showPromoInput && (
                                    <div onClick={() => setShowPromoInput(true)} style={{ fontSize: '13px', color: '#3880ff', fontWeight: '600', cursor: 'pointer' }}>
                                        Have a promo code?
                                    </div>
                                )}
                                {showPromoInput && (
                                    <>
                                        <div style={{ borderTop: '1px solid #e8e8e8', paddingTop: '12px' }}>
                                            <div style={{ fontSize: '12px', color: '#888', marginBottom: '6px' }}>Promo code</div>
                                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', maxWidth: '280px' }}>
                                                <Input id="promo-code" placeholder="Enter code" value={String(promoCode)} onChange={(e) => updatePromoCode(e)} disabled={cartData?.hascheckedout || orderTotal === 0} style={{ flex: 1, fontSize: '14px', height: '40px' }} />
                                                <IonButton disabled={cartData?.hascheckedout || orderTotal === 0} fill="outline" color="primary" onClick={getDiscountAmount} style={{ '--border-radius': '10px', flexShrink: 0, height: '40px', width: '90px' }}>Apply</IonButton>
                                            </div>
                                            {promoCodeAmount > 0 && (
                                                <div style={{ fontSize: '12px', color: '#3880ff', marginTop: '6px', textAlign: 'right' }}>Promo code: -{formatMoney(promoCodeAmount)}</div>
                                            )}
                                            {promoCodeMessage?.length > 0 && (
                                                <div style={{ color: '#e53935', fontSize: '12px', marginTop: '4px' }}>{promoCodeMessage}</div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        )}

                        {(paymentmethod === "CREDIT" && orderTotal > 0 && cartData.allowpaymentoffees && cartData?.paymentprocessorisvalid) && (
                            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer', backgroundColor: '#eef1fb', borderRadius: '8px', padding: '10px 12px', margin: '0 -4px' }}>
                                <CheckBox
                                    name="item"
                                    checked={paymentProcessFeesCheckbox}
                                    handleCheckboxChange={(e: any) => setPaymentProcessFeesCheckbox(e.target.checked)}
                                    param="item"
                                    checkedBackgroundColor="#3880ff"
                                    uncheckedBackgroundColor="white"
                                    height="18px"
                                    width="18px"
                                    borderRadius="4px"
                                    disabled={cartData?.hascheckedout}
                                />
                                <div>
                                    <div style={{ fontSize: '12px', color: '#333' }}>Add {(Math.round(cartData.ccfee * 100) / 100).toFixed(2)}% to cover payment processing fees</div>
                                    <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>This would add {formatMoney(ccTotalFee)} to your total</div>
                                </div>
                            </label>
                        )}

                        <div style={{ marginTop: 'auto', borderTop: '2px solid #111', paddingTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                            <div style={{ fontSize: '16px', fontWeight: '700', color: '#111' }}>Total</div>
                            <div style={{ fontSize: '16px', fontWeight: '700', color: '#111' }}>{formatMoney(orderTotal)}</div>
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div style={{ backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '12px', padding: '16px 20px' }}>
                        <div style={{ fontSize: '11px', fontWeight: '700', color: '#999', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '12px' }}>Billing Information</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                            <div style={{ display: 'flex', gap: '6px' }}>
                                <Input type="text" placeholder="First name" value={firstname} disabled={cartData?.hascheckedout || finishCheckout} required onChange={(e) => setFirstName(e.currentTarget.value)} style={{ flex: 1, height: '34px', ...(showFieldErrors && !firstname ? { borderColor: 'red' } : {}) }} />
                                <Input type="text" placeholder="Last name" value={lastname} disabled={cartData?.hascheckedout || finishCheckout} required onChange={(e) => setLastName(e.currentTarget.value)} style={{ flex: 1, height: '34px', ...(showFieldErrors && !lastname ? { borderColor: 'red' } : {}) }} />
                            </div>
                            <Input type="text" placeholder="Company" value={company} disabled={cartData?.hascheckedout || finishCheckout} onChange={(e) => setCompany(e.currentTarget.value)} style={{ width: '100%', height: '34px' }} />
                            <Input type="text" placeholder="Address" value={address1} disabled={cartData?.hascheckedout || finishCheckout} required onChange={(e) => setAddress1(e.currentTarget.value)} style={{ width: '100%', height: '34px', ...(showFieldErrors && !address1 ? { borderColor: 'red' } : {}) }} />
                            <div style={{ display: 'flex', gap: '6px' }}>
                                <Input type="text" placeholder="City" value={city} disabled={cartData?.hascheckedout || finishCheckout} required onChange={(e) => setCity(e.currentTarget.value)} style={{ flex: 1, height: '34px', ...(showFieldErrors && !city ? { borderColor: 'red' } : {}) }} />
                                <Select name="state" id="id" value={state} disabled={cartData?.hascheckedout || finishCheckout} required onChange={(e) => setState(e.currentTarget.value)} style={{ width: '70px', height: '34px' }}>
                                    {usStates.map((stateO, index) => <Option value={stateO.abbreviation} key={index}>{stateO.abbreviation}</Option>)}
                                </Select>
                                <Input type="text" placeholder="Zip" value={zip} disabled={cartData?.hascheckedout || finishCheckout} required onChange={(e) => setZip(e.currentTarget.value)} style={{ width: '80px', height: '34px', ...(showFieldErrors && !zip ? { borderColor: 'red' } : {}) }} />
                            </div>
                            <Input type="text" placeholder="Email" value={email} disabled={cartData?.hascheckedout || finishCheckout} required onChange={(e) => setEmail(e.currentTarget.value)} style={{ width: '100%', height: '34px', ...(showFieldErrors && cartData?.requiredemail && !emailRegex.test(email) ? { borderColor: 'red' } : {}) }} />
                            <Input type="tel" placeholder="Phone" value={phone} disabled={cartData?.hascheckedout || finishCheckout} onChange={(e) => {
                                const digits = e.currentTarget.value.replace(/\D/g, '').slice(0, 10);
                                const formatted = digits.length <= 3 ? digits : digits.length <= 6 ? `(${digits.slice(0, 3)}) ${digits.slice(3)}` : `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
                                setPhone(formatted);
                            }} style={{ width: '100%', height: '34px' }} />
                        </div>
                    </div>

                    {!cartData?.hascheckedout &&
                        <div style={{ backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '12px', padding: '16px 20px' }}>
                            <div style={{ fontSize: '11px', fontWeight: '700', color: '#999', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '12px' }}>Payment</div>
                            <Select name="paymentmethod" id="paymentmethod" value={paymentmethod}  onChange={(e) => {
                                    if (paymentmethod === 'CREDIT' && e.currentTarget.value !== 'CREDIT') {
                                        stripePaymentElement?.unmount();
                                        setStripePaymentElement(null);
                                        setStripeElement(null);
                                    }
                                    setPaymentMethod(e.currentTarget.value);
                                }} style={{ width: '100%', height: '34px', marginBottom: '12px' }}>
                                {orderTotal === 0 && <Option value={'FREE'} key={'free'}>FREE</Option>}
                                {orderTotal > 0 && <>
                                    <Option value={'CREDIT'} key={'cc'}>Credit / Debit Card</Option>
                                </>}
                                {cartData?.billme == true && <Option value={'BILLME'} key={'bm'}>Bill Me</Option>}
                            </Select>
                            {(paymentmethod === "CREDIT" && cartData?.paymentprocessorcode === 1) && <GoEmerchant />}
                            <iframe
                                key={invalidateIframe}
                                title="1stpayment-iframe"
                                id="firstpay-iframe"
                                src={cartData?.paymentprocessorinfo?.creditcardiframe}
                                data-transcenter-id={cartData?.paymentprocessorinfo?.transcenterid}
                                data-processor-id={cartData?.paymentprocessorinfo?.processorid}
                                data-transaction-type={cartData?.paymentprocessorinfo?.transactiontype}
                                data-manual-submit="false"
                                style={{ display: (paymentmethod === "CREDIT" && cartData?.paymentprocessorcode === 1 && orderTotal > 0 ? 'inline' : 'none') }}
                            />
                            <div
                                style={{ display: (paymentmethod === "CREDIT" && cartData?.paymentprocessorcode === 2 && (orderTotal > 0 || orderTotal === undefined) ? 'block' : 'none') }}
                                id="payment-element"
                            />
                        </div>
                    }
                </div>
            </div>
        )
    }

    const inputRef = useRef<HTMLIonInputElement>(null);
    const contentRef = useRef<HTMLIonContentElement>(null);

    return (
        <>
            <IonLoading isOpen={isLoading}/>
            <IonToast
                isOpen={toastState.display}
                onDidDismiss={() => {
                    if (toastState.goback) {
                        navigate(-1)
                    }
                    setToastState({
                        display: false,
                        goback: false,
                        message: ''
                    })
                }}
                cssClass={'custom-toast'}
                message={toastState.message}
                duration={3000}
            />
            {summaryModal.active &&
                <IonModal
                    isOpen={true}
                    onWillDismiss={(ev) => onWillDismiss(ev)}
                >
                    <IonBackdrop />
                    <ModalContent>
                        <h1>{"Checkout Successful"}</h1>
                        <h2>Purchase Summary</h2>
                        {/*<IonRow style={{marginTop: '20px'}}>*/}
                        {/*    <IonCol size="12" className="ion-justify-content-begin">*/}
                        {/*        <Text textAlign="left"  fontWeight="800" fontSize="22px" color="#0a0a0a" >*/}
                        {/*            {firstname + ' ' + lastname + ' - ' + email}*/}
                        {/*        </Text>*/}
                        {/*    </IonCol>*/}
                        {/*</IonRow>*/}
                        {/*<IonRow style={{marginTop: '10px'}}>*/}
                        {/*    <IonCol size="12" className="ion-justify-content-begin">*/}
                        {/*        <Text textAlign="left"  fontWeight="800" fontSize="22px" color="#0a0a0a" >*/}
                        {/*            {address1 + ' ' + city + ', ' + state + ' ' + zip}*/}
                        {/*        </Text>*/}
                        {/*    </IonCol>*/}
                        {/*</IonRow>*/}
                        <IonRow style={{marginTop: '10px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Subtotal:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + subtotalTotal}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Discount:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + promoCodeAmount}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Additional Donation:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + additionalDonationFinal}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'CC Fees:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + ccTotal}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Total Amount:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {'$' + orderTotal}
                                </Text>
                            </IonCol>
                        </IonRow>
                        <IonRow style={{marginTop: '5px'}}>
                            <IonCol size="8" className="ion-justify-content-begin">
                                <Text textAlign="left"  fontSize="20px" color="#0a0a0a" >
                                    {'Payment Method:'}
                                </Text>
                            </IonCol>
                            <IonCol size="4">
                                <Text textAlign="right" fontSize="18px" color="#0a0a0a">
                                    {paymentmethod}
                                </Text>
                            </IonCol>
                        </IonRow>
                    </ModalContent>
                    <IonRow style={{marginBottom: '20px'}}>
                        <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                            <IonButton onClick={() => { setQuantityModal({active: false, quantity: 0, item:''})}} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                Close
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonModal>
            }
            {logoModal.active &&
                <IonModal
                    isOpen={true}
                    onWillDismiss={(ev) => {}}
                    backdropDismiss={false}
                    // initialBreakpoint={0.5}
                >
                    <LogoModalContent>
                        <IonToolbar>
                            <IonTitle>{logoModal.name}</IonTitle>
                            <IonButtons slot="end" onClick={() => { setLogoModal({active: false, url: '', name:'', desc: ''})}}>
                                <IonIcon
                                    // slot="icon-only"
                                    icon={closeOutline}
                                    style={{width: 30, height: 30, color: "#000000"}}
                                />
                            </IonButtons>
                        </IonToolbar>

                        <IonRow>
                            <IonCol>
                                {(logoModal?.url && logoModal?.url.length > 0) &&
                                    <img style={{maxWidth: '425px', maxHeight: '425px'}} alt="" src={logoModal?.url} />
                                }
                            </IonCol>
                        </IonRow>
                        <IonCardSubtitle style={{marginTop: '15px'}}>{logoModal.desc}</IonCardSubtitle>
                    </LogoModalContent>
                </IonModal>
            }
            {quantityModal.active &&
                <IonModal
                    isOpen={true}
                    onWillDismiss={(ev) => onWillDismiss(ev)}
                >
                    <IonBackdrop />
                    <ModalContent>
                        <h1>{"Insuffcient Quantity Available"}</h1>
                        <h2>{"We're sorry, but the quantity available is lower than you seleced:"}</h2>
                        <IonRow style={{marginTop: '20px'}}>
                            <IonCol size="6" className="ion-justify-content-begin">
                                <Text textAlign="right"  fontWeight="800" fontSize="18px" color="#a2a2a2" >
                                    {quantityModal.item + ':'}
                                </Text>
                            </IonCol>
                            <IonCol size="6">
                                    <Text textAlign="left" fontWeight="800" fontSize="18px" color="#a2a2a2">
                                        {quantityModal.quantity + ' Remaining'}
                                    </Text>
                            </IonCol>
                        </IonRow>
                    </ModalContent>
                    <IonRow style={{marginBottom: '20px'}}>
                        <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                            <IonButton onClick={() => { setQuantityModal({active: false, quantity: 0, item:''})}} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                Ok
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonModal>
            }
            {maxQuantityPerTransModel.active &&
                <IonModal
                    isOpen={true}
                    onWillDismiss={(ev) => onWillDismiss(ev)}
                >
                    <IonBackdrop />
                    <ModalContent>
                        <h1>{"Max quantity per transaction exceeded"}</h1>
                        <h2>{"We're sorry, but the max quantity per transaction was exceeded:"}</h2>
                        <IonRow style={{marginTop: '20px'}}>
                            <IonCol size="6" className="ion-justify-content-begin">
                                <Text textAlign="right"  fontWeight="800" fontSize="18px" color="#a2a2a2" >
                                    {maxQuantityPerTransModel.name + ':'}
                                </Text>
                            </IonCol>
                            <IonCol size="6">
                                <Text textAlign="left" fontWeight="800" fontSize="18px" color="#a2a2a2">
                                    {maxQuantityPerTransModel.maxquantity + ' Max'}
                                </Text>
                            </IonCol>
                        </IonRow>
                    </ModalContent>
                    <IonRow style={{marginBottom: '20px'}}>
                        <IonCol style={{display: 'flex'}} className="ion-justify-content-center">
                            <IonButton onClick={() => { setQuantityModal({active: false, quantity: 0, item:''})}} size="large" style={{ width: '80%' }} expand="block" fill="solid" color={'primary'}>
                                Ok
                            </IonButton>
                        </IonCol>
                    </IonRow>
                </IonModal>
            }

            <IonContent ref={contentRef} style={{height: '100%'}}>
                <IonHeader>
                    <IonToolbar style={{ '--background': '#ffffff', '--border-color': '#e0e0e0', boxShadow: '0 2px 4px rgba(0,0,0,0.06)' }}>
                        {/* Row 1: back button + title */}
                        <IonButtons slot={'start'}>
                            <IonButton onClick={() => {navigate(`/${eventcode}/event/`)}} fill="clear" color="medium">
                                <IonIcon
                                    icon={arrowBack}
                                    slot="icon-only"
                                    color={"medium"}
                                    style={{ width: 24, height: 24, paddingRight: '5px'}}
                                />
                                <Text
                                    className={"ion-hide-md-down"}
                                    style={{overflow: 'hidden'}}
                                    fontSize="15px"
                                    color="black"
                                    textAlign="center"
                                >
                                    Back to Event Home
                                </Text>
                            </IonButton>
                        </IonButtons>

                        <IonTitle className={"ion-no-padding"}>
                            <Text
                                fontSize="18px"
                                color="#111"
                                fontWeight="700"
                                textAlign="center"
                                flexWrap={'wrap'}
                            >
                                {storeData?.storewelcomeeventname}
                            </Text>
                        </IonTitle>
                    </IonToolbar>

                    <IonToolbar style={{ '--background': '#ffffff', '--min-height': 'auto', '--padding-top': '0', '--padding-bottom': '4px' }}>
                        {/* Row 2: timer */}
                        <div style={{ textAlign: 'center', fontSize: '11px', color: '#222', fontWeight: '700', padding: '2px 0 4px' }}>
                            {lstMessage}
                        </div>
                        {/* Row 3: tabs */}
                        <IonRow>
                            {storeData && storeData?.tabs && storeData?.tabs.map((item, index) => {
                                const tabEnabled = item.tabname === 'Tickets'
                                    ? storeData.hastickets
                                    : item.tabname === 'Merchandise'
                                    ? storeData.hasMerch
                                    : item.enabled;
                                return (
                                    <IonCol onClick={() => {
                                        if (tabEnabled) {
                                            setSelectedTab(item.tabname)
                                        }
                                    }}>
                                        <IonTabButton disabled={!tabEnabled} selected={selectedTab === item.tabname}>
                                            <FontAwesomeIcon size="2x" icon={item.image} style={{ fontSize: '28px' }}/>
                                            <IonLabel style={{ fontSize: '13px', marginTop: '2px' }}>{item.tabname}</IonLabel>
                                        </IonTabButton>
                                    </IonCol>
                                )
                            })}
                        </IonRow>
                    </IonToolbar>
                </IonHeader>
                <IonGrid>
                {storeData && storeData?.tabs && storeData?.tabs.map((item, index) => {
                    if (item.tabname !== selectedTab) {
                        return;
                    }
                    // if (item.tabname === 'Cart' && selectedTab === 'Cart' && item.heading === checkoutTab) {
                    if (item.tabname === 'Cart') {
                        return (
                            <>
                                {item?.heading?.length > 0 &&
                                    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '12px 16px 0' }}>
                                        <div style={{ fontSize: '26px', fontWeight: '700', color: '#111' }}>{item.heading}</div>
                                    </div>
                                }
                                {getCart()}
                            </>
                        )
                    }
                    else if (item.tabname === 'Registration' ) {
                        return (
                            <>
                                <RegistrationPage storeData={storeData} setStoreData={setStoreData}
                                                  item={item} eventcode={eventcode} auctioncode={auctioncode}
                                                  onRegistrationStatsChange={setRegistrationStats}
                                                  onSkipForNow={() => setSkipForNow(true)} />
                            </>
                        )
                    }
                    else if (selectedTab === item.tabname) {
                        const allTicketMerchItems = storeData.tabs
                            .filter((t: any) => t.tabname === 'Tickets' || t.tabname === 'Merchandise')
                            .flatMap((t: any) => t.sections.flatMap((s: any) => s?.data || []))
                            .filter((i: any) => i && i?.name?.length > 0)
                        const totalAmount = allTicketMerchItems.reduce((acc: number, i: any) => acc + (Number(itemPrice[i.id]?.split("$").pop()) || 0), 0)
                        const totalQty = allTicketMerchItems.reduce((acc: number, i: any) => acc + (itemQuantity[i.id] ?? 0), 0)

                        return (
                            <>
                                {/* Cards area */}
                                <div style={{ paddingBottom: '70px' }}>
                                    {item?.heading?.length > 0 &&
                                        <div style={{ marginLeft: '15px', marginTop: '10px', fontSize: '26px' }}><b>{item.heading}</b></div>
                                    }
                                    {item.sections.map((section: any) => {
                                        if (section && validSectionData(section.data)) {
                                            return getDataItems(section.data)
                                        }
                                    })}
                                </div>

                                <div style={{
                                    position: 'fixed',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    zIndex: 1000,
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    width: '100%',
                                    maxWidth: '800px',
                                    padding: '8px 16px',
                                    gap: '12px',
                                    backgroundColor: '#fff',
                                    borderTop: '1px solid #e0e0e0',
                                    boxShadow: '0 -2px 8px rgba(0,0,0,0.08)',
                                    borderRadius: '12px 12px 0 0',
                                }}>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: '18px', fontWeight: 'bold', lineHeight: '1.2' }}>{formatMoney(totalAmount)}</div>
                                        <div style={{ fontSize: '12px', color: '#888' }}>{totalQty} items</div>
                                    </div>
                                    {hasBack() &&
                                        <IonButton
                                            disabled={cartExpired}
                                            onClick={goBack}
                                            fill="outline"
                                            color="primary"
                                            style={{ '--border-radius': '8px', height: '44px', margin: 0 }}
                                        >
                                            Back
                                        </IonButton>
                                    }
                                    {hasNext() &&
                                        <IonButton
                                            disabled={cartExpired}
                                            onClick={goNext}
                                            fill="solid"
                                            color="primary"
                                            style={{ '--border-radius': '8px', height: '44px', margin: 0 }}
                                        >
                                            Next
                                        </IonButton>
                                    }
                                </div>
                                </div>
                            </>
                        )
                    }
                })}
                    {getButtons()}
                </IonGrid>
                <div style={{ textAlign: 'center', marginTop: '2px', marginBottom: '90px', padding: '0 16px' }}>
                    <div style={{ fontSize: '11px', color: '#aaa' }}>
                        EventSnap™. All Rights Reserved by DonorSnap.
                    </div>
                    <div style={{ borderTop: '1px solid #e0e0e0', margin: '6px auto', width: '30%' }} />
                    <div>
                        <Link style={{ fontSize: '11px', color: '#e53935', textDecoration: 'none' }} to={"/" + eventcode + "/privacy-policy"}>Privacy Policy</Link>
                    </div>
                </div>
            </IonContent>
        </>
    )
}

export default RegisterPage
